/** ASO Translate tool (/marketing/aso-translate) — Play Store listing translation via codex/claude CLI. */
export const asoTranslate: Record<string, string> = {
  'nav.growth.asoTranslate': 'ASO Translate',
  'aso.title': 'ASO Translate',
  'aso.tab.translate': 'Dịch',
  'aso.tab.jobs': 'Jobs',
  'aso.tab.detail': 'Chi tiết job',
  'aso.tab.logs': 'Logs',
  'aso.logs.pickJob': 'Chọn job',
  'aso.logs.pickJobHint': 'Chọn một job để xem log',
  'aso.detail.status': 'Trạng thái',
  'aso.detail.langsDone': 'ngôn ngữ đã dịch',
  'aso.detail.failed': 'lỗi',
  'aso.detail.pickLanguage': 'Chọn ngôn ngữ',
  'aso.detail.stillRunning': 'Job đang chạy — kết quả hiển thị khi hoàn tất.',
  'aso.detail.noResult': 'Chưa có kết quả lưu cho job này.',
  'aso.form.appName': 'Tên app',
  'aso.form.shortDesc': 'Mô tả ngắn',
  'aso.form.longDesc': 'Mô tả dài',
  'aso.form.sheetUrl': 'Nạp nội dung từ Google Sheet (dán link)',
  'aso.form.sheetLoad': 'Nạp từ Sheet',
  'aso.form.sheetLoading': 'Đang nạp...',
  'aso.form.sheetLoaded': 'Đã nạp nội dung từ tab "{sheet}"',
  'aso.form.sheetNoContent': 'Tab "{sheet}" không có dòng appName/shortDesc/longDesc nhận dạng được',
  'aso.form.sheetName': 'Tên sheet (tab)',
  'aso.form.sheetNameHint': 'Bắt buộc trừ khi bật chế độ Dry run',
  'aso.form.engine': 'Engine',
  'aso.form.engineCodex': 'Codex',
  'aso.form.engineClaude': 'Claude',
  'aso.form.languages': 'Ngôn ngữ đích',
  'aso.form.languagesAll': 'Tất cả',
  'aso.form.extraPrompt': 'Yêu cầu bổ sung (tuỳ chọn)',
  'aso.form.dryRun': 'Dry run (chỉ dịch, không đẩy Google Sheet)',
  'aso.form.submit': 'Tạo job dịch',
  'aso.form.submitting': 'Đang gửi...',
  'aso.form.modeSingle': '1 app',
  'aso.form.modeBatch': 'Nhiều app',
  'aso.form.batchUrls': 'Danh sách Google Sheet URL (mỗi dòng 1 app)',
  'aso.form.batchHint': 'Mỗi dòng 1 link tab sheet nguồn; kết quả mỗi app ghi vào tab trùng tên tab nguồn',
  'aso.form.batchNoUrls': 'Chưa nhập URL nào',
  'aso.form.batchSubmit': 'Tạo job cho tất cả',
  'aso.form.batchNoContent': 'không có dòng appName/shortDesc/longDesc nhận dạng được',
  'aso.form.batchQueued': 'đã vào hàng đợi',
  'aso.form.errorSheetRequired': 'Cần nhập tên sheet trừ khi bật Dry run',
  'aso.form.errorNoLanguages': 'Chọn ít nhất một ngôn ngữ đích',
  'aso.jobs.empty': 'Chưa có job nào',
  'aso.jobs.colTime': 'Thời gian',
  'aso.jobs.colActor': 'Người tạo',
  'aso.jobs.colEngine': 'Engine',
  'aso.jobs.colSheet': 'Sheet',
  'aso.jobs.colProgress': 'Tiến độ',
  'aso.jobs.colStatus': 'Trạng thái',
  'aso.jobs.colActions': 'Thao tác',
  'aso.jobs.cancel': 'Hủy',
  'aso.jobs.viewLog': 'Xem log',
  'aso.jobs.logEmpty': 'Chưa có log',
  'aso.status.queued': 'Đang chờ',
  'aso.status.running': 'Đang chạy',
  'aso.status.done': 'Hoàn tất',
  'aso.status.failed': 'Lỗi',
  'aso.status.cancelled': 'Đã hủy',
}
